import get from 'lodash/get';
import { utcToZonedTime } from 'date-fns-tz';

export const formatOrderTime = (
  ecommerceEnabled,
  t,
  { pickupTime, timeSlot, isAsap },
  locale,
  dateFnsLocale,
  formatTimeDate,
  formatTimeSlot,
  timezone
) => {
  const dateFormatted = formatTimeDate(
    timezone ? utcToZonedTime(pickupTime, timezone) : new Date(pickupTime),
    'DATE',
    locale,
    dateFnsLocale,
  );

  const selectedLocale = get(dateFnsLocale, 'code', locale);
  if (isAsap) {
    return t('ASAP');
  }

  if (ecommerceEnabled) {
    return dateFormatted;
  }

  return `${dateFormatted} at ${formatTimeSlot(timeSlot.slot, timeSlot.windowLength, selectedLocale)}`;
};
